/**
 * @generated SignedSource<<42aef17594c408dcead6ad915fe594c2>>
 * @relayHash f8cfb4af0b45d6c2f5a6c82b1d276ff3
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/554.0.0-2026-04-02T20:05:27.583Z/NavRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavRefetchQuery$variables = {
  customBannerText?: string | null;
  dotComHost: string;
  hasSellerPk: boolean;
  hyperwalletLink: string;
  renderNotifications?: boolean | null;
  sellerPk: string;
  userId?: string | null;
};
export type NavRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"SellerNav_viewer">;
  };
};
export type NavRefetchQuery = {
  response: NavRefetchQuery$data;
  variables: NavRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customBannerText"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dotComHost"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hasSellerPk"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hyperwalletLink"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "renderNotifications"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sellerPk"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "href",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "interactionType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hideSideNavTitle",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataTn",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newWindow",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NavRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "renderNotifications",
                "variableName": "renderNotifications"
              }
            ],
            "kind": "FragmentSpread",
            "name": "SellerNav_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NavRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "presenceFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "presence"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"presence\")"
          },
          {
            "alias": "onSessionSellerChargesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "onSessionSellerBillingStatementCharges"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"onSessionSellerBillingStatementCharges\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "customBannerText",
                "variableName": "customBannerText"
              },
              {
                "kind": "Variable",
                "name": "dotComHost",
                "variableName": "dotComHost"
              },
              {
                "kind": "Variable",
                "name": "hyperwalletLink",
                "variableName": "hyperwalletLink"
              },
              {
                "kind": "Variable",
                "name": "sellerPk",
                "variableName": "sellerPk"
              },
              (v1/*: any*/)
            ],
            "concreteType": "DealerNavBar",
            "kind": "LinkedField",
            "name": "dealerNavBar",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NavBarButton",
                "kind": "LinkedField",
                "name": "buttons",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NavBarLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "navItems",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isNavBarElement"
                      },
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v4/*: any*/),
                      (v10/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NavBarListItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "type": "NavBarElement",
                                "abstractKey": "__isNavBarElement"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "NavBarList",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              {
                "condition": "renderNotifications",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "notifications",
                    "args": null,
                    "concreteType": "DealerNavBarBadges",
                    "kind": "LinkedField",
                    "name": "badges",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "listings",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "orders",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "messages",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "recommendations",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          {
            "condition": "hasSellerPk",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "sellerId",
                    "variableName": "sellerPk"
                  }
                ],
                "concreteType": "Seller",
                "kind": "LinkedField",
                "name": "seller",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RepData",
                    "kind": "LinkedField",
                    "name": "sellerRep",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vertical",
                    "storageKey": null
                  },
                  {
                    "alias": "isItemUploadV2RedesignWhitelisted",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "listName",
                        "value": "ITEM_UPLOAD_V2_REDESIGN"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "isWhitelisted",
                    "storageKey": "isWhitelisted(listName:\"ITEM_UPLOAD_V2_REDESIGN\")"
                  },
                  {
                    "alias": null,
                    "args": [
                      (v1/*: any*/)
                    ],
                    "concreteType": "CreateListingOption",
                    "kind": "LinkedField",
                    "name": "createListingOptions",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BillingProfile",
                    "kind": "LinkedField",
                    "name": "billingProfile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "runningBalance",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VatConfiguration",
                    "kind": "LinkedField",
                    "name": "vatConfiguration",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priceBookName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresenceResults",
                    "kind": "LinkedField",
                    "name": "presence",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "recentOnlineDate",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SellerPreferences",
                    "kind": "LinkedField",
                    "name": "sellerPreferences",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "showOnlineStatus",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SellerProfile",
                    "kind": "LinkedField",
                    "name": "sellerProfile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "company",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/554.0.0-2026-04-02T20:05:27.583Z/NavRefetchQuery",
    "metadata": {},
    "name": "NavRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "34a71025ee4ca46d5e751d729642a91e";

export default node;
